<p-dialog header="Adicionar Disciplina" [modal]="true" [(visible)]="visibleDisciplinaForm" (onHide)="close.emit()"
  [style]="{ width: '40rem' }">
  <form [formGroup]="disciplinaForm" (ngSubmit)="saveDisciplina()">
    <div class="p-fluid grid">
      <!-- Checkbox para Nova Disciplina -->
      <div class="field col-12 d-flex flex-row justify-content-end align-items-center" style="gap: 5px;">
        <label for="isNewDisciplina">Nova Disciplina</label>
        <p-checkbox inputId="isNewDisciplina" formControlName="isNewDisciplina" binary="true"></p-checkbox>
      </div>

      <!-- Campo Dinâmico: Selecionar Disciplina ou Digitar Nova -->
      <div class="field col-12 d-flex flex-column">
        <label for="disciplina">
          {{
          disciplinaForm.get('isNewDisciplina')?.value
          ? 'Nome da Nova Disciplina'
          : 'Selecionar Disciplina'
          }}
        </label>
        <ng-container *ngIf="!disciplinaForm.get('isNewDisciplina')?.value; else newDisciplinaInput">
          <p-select inputId="disciplina" appendTo="body" formControlName="disciplinaID" [options]="disciplinaOptions"
            optionLabel="label" optionValue="value" placeholder="Selecione uma disciplina"></p-select>
        </ng-container>
        <ng-template #newDisciplinaInput>
          <input inputId="disciplinaDesignacao" type="text" pInputText formControlName="disciplinaDesignacao"
            placeholder="Digite o nome da disciplina" />
        </ng-template>
        <div class="error-message">
          <p-message
            *ngIf="disciplinaForm.get('disciplinaDesignacao')?.invalid && disciplinaForm.get('disciplinaDesignacao')?.touched"
            severity="error" text="Campo obrigatório"></p-message>
        </div>
      </div>

      <!-- Regime
      <div class="field col-6 d-flex flex-column">
        <label for="regime">Regime</label>
        <p-select
          inputId="regime"
          appendTo="body"
          formControlName="regime"
          [options]="semestre"
          optionLabel="name"
          optionValue="name"
          placeholder="Selecione o regime"
        ></p-select>
        <div class="error-message">
          <p-message
            *ngIf="disciplinaForm.get('regime')?.invalid && disciplinaForm.get('regime')?.touched"
            severity="error"
            text="Campo obrigatório"
          ></p-message>
        </div>
      </div>
      -->
      <!-- TipoPeriodo -->
      <div class="field col-6 d-flex flex-column">
        <label for="tipoPeriodo">Tipo de Período</label>
        <p-select inputId="tipoPeriodo" appendTo="body" formControlName="tipoPeriodoID" [options]="tipoPedidoList"
          optionLabel="label" optionValue="value" placeholder="Selecione o tipo de período"></p-select>
        <div class="error-message">
          <p-message
            *ngIf="disciplinaForm.get('tipoPeriodoID')?.invalid && disciplinaForm.get('tipoPeriodoID')?.touched"
            severity="error" text="Campo obrigatório"></p-message>
        </div>
      </div>

      <!-- Período -->
      <div class="field col-6 d-flex flex-column">
        <label for="periodo">Período</label>
        <p-select inputId="periodo" appendTo="body" formControlName="periodoID" [options]="periodoList"
          optionLabel="label" optionValue="value" placeholder="Selecione o período"></p-select>
        <div class="error-message">
          <p-message *ngIf="disciplinaForm.get('periodoID')?.invalid && disciplinaForm.get('periodoID')?.touched"
            severity="error" text="Campo obrigatório"></p-message>
        </div>
      </div>

      <!-- Carga Horária -->
      <div class="field col-12 d-flex flex-column">
        <label for="cargaHoraria">Carga Horária</label>
        <p-inputnumber inputId="cargaHoraria" formControlName="cargaHoraria" [min]="1"></p-inputnumber>
        <div class="error-message">
          <p-message *ngIf="disciplinaForm.get('cargaHoraria')?.invalid && disciplinaForm.get('cargaHoraria')?.touched"
            severity="error" text="Campo obrigatório"></p-message>
        </div>
      </div>
    </div>

    <!-- Ações -->
    <div class="flex justify-content-between">
      <p-button label="Cancelar" class="p-button-secondary" (click)="close.emit()"></p-button>
      <p-button label="Salvar" class="p-button-primary" type="submit"></p-button>
    </div>
  </form>
</p-dialog>